import React from "react";
import { TabsContainer, TabButton } from "./Tabs.styled";

export interface Tab<T extends string | number = string> {
  id: T;
  label: string;
}

interface TabsProps<T extends string | number = string> {
  tabs: Tab<T>[];
  activeTab: T;
  onTabChange: (tabId: T) => void;
}

/**
 * Reusable tabs component
 * Generic type T allows for different tab ID types (string, number, etc.)
 */
function Tabs<T extends string | number = string>({
  tabs,
  activeTab,
  onTabChange,
}: TabsProps<T>) {
  return (
    <TabsContainer>
      {tabs.map((tab) => (
        <TabButton
          key={tab.id}
          data-active={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </TabButton>
      ))}
    </TabsContainer>
  );
}

export default Tabs;
